export const environment = {
    production: true,
    urls: {
        api: 'https://api.n2g-iona-staging.net/v2/',
        auth: 'https://iona-staging.wla-backend.de/auth'
    }
};


